import { styled } from '@mui/system';
import Link from '@mui/material/Link';

export const ItemContainer = styled('li')(({ theme }) => ({
  '&&': {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    width: '100%',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: theme.palette.grey['100']
  },
  // getOptionDisabled does not work properly
  '&[aria-disabled=true]': {
    cursor: 'default',
    background: 'none',
    color: theme.palette.grey['400'],
    '& svg': {
      color: theme.palette.grey['400']
    }
  }
}));

export const EmailLink = styled(Link)({
  fontSize: '0.8rem',
  pointerEvents: 'auto'
});

export const iconStyle = theme => ({
  marginRight: theme.spacing(1),
  color: theme.palette.grey[700]
});

export const Name = styled('span')({
  display: 'inherit'
});

export const UserEmail = styled('span')({
  color: '#0000008a',
  fontSize: 12
});
